import React from 'react';
import './Agenda.css';
import VideoPresent from './VideoPresent/VideoPresent';
import BlueFire from '../../img/agenda/BlueFire.png'
import codemagicio from '../../img/agenda/codemagicio.png'
import DevAngels from '../../img/agenda/DevAngels.png'
import Klingsbo from '../../img/agenda/Klingsbo.png'
import Lightfoot from '../../img/agenda/Lightfoot.png'
import Lin from '../../img/agenda/Lin.png'

export default class Agenda extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {
                    time: '09:10',
                    day: 'Tuesday, Feb 07',
                    photo: Lightfoot,
                    name: 'Simon Lightfoot',
                    position: 'CTO',
                    tw: 'https://twitter.com/devangelslondon',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Topic+TBA&dates=20230207T091000Z/20230207T095000Z&details=Abstrakt&location=online',
                    logo: DevAngels,
                    title: 'Remastering Retro 3D Games in Flutter',
                    abstract: `The PlayStation like you’ve never seen it before`,
                },
                {
                    time: '09:55',
                    day: 'Tuesday, Feb 07',
                    photo: Klingsbo,
                    name: 'Lukas Klingsbo',
                    position: 'Senior Developer',
                    tw: 'https://twitter.com/spydon',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=Building+a+multi-player+game+with+Flame&dates=20230207T095500Z/20230207T103500Z&details=Multiplayer+gaming+can+be+quite+a+complex+topic,+in+this+talk+we+will+demystify+this+and+show+different+techniques+of+making+multiplayer+games+in+Flutter+and+Flame.&location=online',
                    logo: BlueFire,
                    title: 'Building a multi-player game with Flame',
                    abstract: `Multiplayer gaming can be quite a complex topic, in this talk we will demystify this and show different techniques of making multiplayer games in Flutter and Flame.`,
                },
                {
                    time: '10:35',
                    day: 'Tuesday, Feb 07',
                    photo: Lin,
                    name: 'Maksim Lin',
                    position: 'Developer Relations Engineer',
                    tw: 'https://twitter.com/mklin',
                    linkAdd: 'https://calendar.google.com/calendar/u/0/r/eventedit?text=CI+to+the+Danger+Zone:+Shipping+Fixes+*Fast*+with+Flutter+&+CI&dates=20230207T103500Z/20230207T111500Z&details=We+all+want+to+ship+high+quality+apps+to+our+customers+but+what+if+something+goes+wrong+and+bugs+slip+through?+Getting+fixes+out+to+customers+*fast*+is+important+and+we+can+use+a+CI+to+help+us+do+that.In+this+talk+we%27ll+look+at+a+Flutter+Flame-based+game+that+can+have+bug+fixes+and+new+features+rolled+out+ASAP.We+will+cover+topics+such+as:-+Using+scripting+to+make+our+game+easier+to+update-+Previewing+and+testing+changes+to+our+app+using+CI+and+Web-+Using+CI+to+securely+roll+out+game+updates+%22over+the+air%22-+Rolling+out+UI+and+logic+updates+OTA+without+rebuilding+our+appAttendees+will+leave+the+talk+with+knowledge+of+how+dynamic+code+updates+can+be+used+for+Flame+games+as+well+as+standard+Flutter+apps+as+well+as+the+challenges+and+limitations+with+doing+so.&location=online',
                    logo: codemagicio,
                    title: 'CI to the Danger Zone: Shipping Fixes *Fast* with Flutter & CI',
                    abstract: `We all want to ship high quality apps to our customers but what if something goes wrong and bugs slip through? Getting fixes out to customers *fast* is important and we can use a CI to help us do that.
                    In this talk we'll look at a Flutter Flame-based game that can have bug fixes and new features rolled out ASAP.
                    We will cover topics such as:
                    - Using scripting to make our game easier to update
                    - Previewing and testing changes to our app using CI and Web
                    - Using CI to securely roll out game updates "over the air"
                    - Rolling out UI and logic updates OTA without rebuilding our app
                    
                    Attendees will leave the talk with knowledge of how dynamic code updates can be used for Flame games as well as standard Flutter apps as well as the challenges and limitations with doing so.`,
                },
            ],
        }
    }

    render() {
        return (
            <div className="agenda" id='agenda'>
                <div className='container agenda'>
                    <h2 className="agenda_title">Agenda</h2>
                    <VideoPresent speakers={this.state.list} />
                    <a className='button agenda_full_btn' href='https://geekle.us/schedule/flutter23' target='_blank' rel="noreferrer">SHOW MORE</a>
                </div>
            </div>
        );
    }
};